import { axiosConfig } from '../baseApi';

export const getAllNotifications = async () => {
	return await axiosConfig('GET', `notifications/all`);
};

export const getUnreadNotifications = async () => {
	return await axiosConfig('GET', `notifications`);
};

export const markNotificationAsRead = async id => {
	return await axiosConfig('POST', `mark_as_read/${id}`);
};
